var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg10 = function Svg10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#10_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.719 38.281c0 11.313-2.25 20.313-6.75 27-4.5 6.656-10.547 9.985-18.14 9.985-8.22 0-14.657-3.36-19.313-10.079-4.625-6.687-6.938-16.03-6.938-28.03 0-11.344 2.313-20.313 6.938-26.907C54.172 3.625 60.453.312 68.359.312c7.97 0 14.188 3.36 18.657 10.079 4.468 6.718 6.703 16.015 6.703 27.89Zm-19.313-.14c0-13.97-2.11-20.953-6.328-20.953-4.187 0-6.281 6.25-6.281 18.75 0 14.937 2.047 22.406 6.14 22.406 2.22 0 3.844-1.625 4.876-4.875 1.062-3.282 1.593-8.39 1.593-15.328Z",
    fill: "#121213"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#10_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.86 74H8.312V18.64H.484V1.626H27.86V74Z",
    fill: "#121213"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#10_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.31 64.164c4.204-6.249 6.409-14.814 6.409-25.883 0-11.656-2.198-20.513-6.369-26.783-4.103-6.17-9.701-9.185-16.99-9.185-7.237 0-12.916 2.98-17.208 9.087-4.31 6.145-6.574 14.662-6.574 25.756 0 11.776 2.274 20.663 6.581 26.892 4.28 6.176 10.102 9.218 17.67 9.218 6.883 0 12.327-2.96 16.48-9.102Zm1.659 1.117c4.5-6.687 6.75-15.687 6.75-27 0-11.875-2.235-21.172-6.703-27.89C82.546 3.67 76.328.312 68.359.312c-7.906 0-14.187 3.313-18.843 9.938-4.625 6.594-6.938 15.563-6.938 26.906 0 12 2.313 21.344 6.938 28.032 4.656 6.718 11.093 10.078 19.312 10.078 7.594 0 13.64-3.329 18.14-9.985Zm-12.23-43.434c1.142 3.781 1.667 9.258 1.667 16.294 0 6.975-.527 12.344-1.689 15.938-.569 1.792-1.361 3.34-2.483 4.46-1.172 1.173-2.636 1.805-4.296 1.805-1.733 0-3.16-.828-4.232-2.13-1.022-1.243-1.756-2.95-2.303-4.943-1.096-4-1.606-9.819-1.606-17.334 0-6.308.522-11.258 1.674-14.697 1.136-3.392 3.19-6.052 6.607-6.052 1.689 0 3.13.73 4.25 1.966 1.07 1.18 1.84 2.804 2.41 4.694ZM72.812 53.47c-1.03 3.25-2.656 4.875-4.874 4.875-4.094 0-6.141-7.469-6.141-22.407 0-12.5 2.094-18.75 6.281-18.75 4.219 0 6.328 6.985 6.328 20.954 0 6.937-.531 12.047-1.594 15.328Z",
    fill: "#D0DF00"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#10_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.313 18.64V74h19.546V1.625H.484v17.016h7.829Zm-5.829-2h7.829V72h15.546V3.625H2.484v13.016Z",
    fill: "#D0DF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "10_svg__a",
    x: 42.578,
    y: 0.313,
    width: 65.141,
    height: 83.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "10_svg__b",
    x: 0.484,
    y: 1.625,
    width: 41.375,
    height: 81.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "10_svg__c",
    x: 42.578,
    y: 0.313,
    width: 65.141,
    height: 83.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "10_svg__d",
    x: 0.484,
    y: 1.625,
    width: 41.375,
    height: 81.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
};
export default Svg10;